import { render, staticRenderFns } from "./ServiceFormV2.vue?vue&type=template&id=528e216d&"
import script from "./ServiceFormV2.vue?vue&type=script&lang=js&"
export * from "./ServiceFormV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports